export enum UserPreferencesType {
  Filters = 'FILTERS',
  Columns = 'COLUMNS',
}
